import React, { useEffect } from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";

import * as select from 'tail.select';

import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function SimpleSelectField(props) {
  const { label, options, placeholder, initialValue, validationSchema, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { summaryMode } = rest;

  const fieldRefClass = "select-" + field.name;
  const { t } = useTranslation();
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  useEffect(() => {
    const _onChange = (item) => {
      setValue(item.key);
    }
    // eslint-disable-next-line
  if (!summaryMode) {
    let SelectFieldObject = null;
    const actSelect = () => {
      try {
        SelectFieldObject = select('.' + fieldRefClass, {
          classNames: "gcap-tail-select default",     // For our demonstration only
          descriptions: true,
          initialValue: initialValue,
          placeholder: placeholder,
          locale: "it",
          width: "100%",
        })
        if (SelectFieldObject) {
          SelectFieldObject.on("change", _onChange);
        }
      }
      catch (error) {
        console.log('Cannot rendered field' + fieldRefClass)
      }
    }
    if (SelectFieldObject) {
      SelectFieldObject.on("change", SelectFieldObject.init());
      console.log('initializeddd')
    }
    actSelect();
    return () => {
      document.removeEventListener('DOMContentLoaded', actSelect);
    };
  }
  // eslint-disable-next-line
  }, [fieldRefClass, placeholder]);

  return (
    <Form.Group className={meta.touched && meta.error ? "has-error" : ""}>
      {!summaryMode ? (
        <>
          {label && (
            <Form.Label
              htmlFor={field.name}
              className="paragraph-small-fs9 font-color-1"
            >
              {label}
            </Form.Label>
           )}
          <Form.Control
            as="select"
            className={`${fieldRefClass} ${
              meta.touched && meta.error ? "is-invalid" : ""
            }`}
            {...field}
            value={field.value}
             id={field.name}
            required={isRequired}
          >
            {(options || []).map((option) => {
              let properLabel = option.label;
              if (
                typeof option.label === "object" &&
                option.label.props &&
                option.label.props.i18nKey
              ) {
                properLabel = t(option.label.props.i18nKey);
              }
              return (
                <option
                  value={option.value}
                  key={field.name + "__" + option.value}
                >
                  {properLabel}
                </option>
              );
            })}
          </Form.Control>

          {meta.touched && meta.error && (
             <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
        </>
      ) : (
        <>
          <span className="paragraph-small-fs9">{label}</span>
          <SummaryItem value={field.value} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
